import { InputControlled } from "./InputControlled";

export { InputControlled };
